import { defaultHeaders, HttpMethod } from '../constants';
import { VirtualFolderResponse } from '../types';
import { ApiConfig } from './types';

const VirtualFoldersApi = ({ baseUrl, fetchWithToken }: ApiConfig) => {
  const url = `${baseUrl}/rfis/virtual-folders`;
  return {
    create(): Promise<VirtualFolderResponse> {
      return fetchWithToken<VirtualFolderResponse>(url, {
        method: HttpMethod.Post,
        headers: defaultHeaders,
      });
    },
  };
};

export default VirtualFoldersApi;
